import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { avatarPrefixCls } from "@/base/components/avatar/Avatar.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Avatar">> = ({
  fontWeight,
  textFontSize,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${avatarPrefixCls}`]: {
      [`.${avatarPrefixCls}-string`]: {
        fontWeight: fontWeight,
        fontSize: `${textFontSize}px`,
      },
    },
  },
});

export const useAvatarStyle = genComponentStyleHook(
  ["Avatar", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
